import type { OperationTypeTrancheEnum } from './enums/OperationTypeTrancheEnum';

export type OperationTrancheResponse = {
	id: number;
	typeTranche: OperationTypeTrancheEnum;
	numero: number;
	dateAGE: string;
	montantSouscrit: number;
	nbSouscripteurs: number;
	montantInvestiNet: number;
};

export type OperationTrancheModel = {
	id: number;
	typeTranche: OperationTypeTrancheEnum;
	numero: number;
	dateAGE: string;
	montantSouscrit: number;
	nbSouscripteurs: number;
	montantInvestiNet: number;
};

export const translateOperationTrancheResponse = (
	o: OperationTrancheResponse
): OperationTrancheModel => {
	return {
		id: o.id,
		typeTranche: o.typeTranche,
		numero: o.numero,
		dateAGE: o.dateAGE,
		montantSouscrit: o.montantSouscrit ?? 0,
		nbSouscripteurs: o.nbSouscripteurs,
		montantInvestiNet: o.montantInvestiNet
	};
};

export const translateOperationTrancheResponseArray = (
	tranchesArr: OperationTrancheResponse[]
): OperationTrancheModel[] => {
	return tranchesArr.map((e) => translateOperationTrancheResponse(e));
};
